import { useMutation } from "@tanstack/react-query";
import api from "../../../api";
import { toast } from "react-toastify";
import { toastStyles } from "../../../styles/styles";
import { PAGE_CONFIG } from "../config";

export const useUpdateConstitution = (queryClient, theme, onSuccessCallback) => {
    const { mutate: updateConstitution, status: updateStatus, isPending: isUpdating } = useMutation({
        mutationFn: (data) => api.constitutions.updateConstitution(data),
        onSuccess: (data) => {
            toast.success(data?.message || 'Constitution updated successfully', { ...toastStyles, theme: theme });
            queryClient.invalidateQueries([PAGE_CONFIG.GET_QUERY_KEY]);
            onSuccessCallback && onSuccessCallback();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || 'Constitution update failed', { ...toastStyles, theme: theme });
        }
    });

    return { updateConstitution, isUpdating, updateStatus };
}